// react-native-share → Web Share API on web, with a download-link fallback
module.exports = {
  open: async ({ url, title, message } = {}) => {
    if (navigator.share) {
      try {
        await navigator.share({ title, text: message, url });
        return { success: true, message: 'Shared' };
      } catch (e) {
        return { success: false, message: e.message };
      }
    }
    if (url) {
      const link = document.createElement('a');
      link.href = url;
      link.download = title || 'receipt';
      link.click();
    }
    return { success: true, message: 'Downloaded' };
  },
  shareSingle: async () => {
    throw new Error('Not implemented');
  },
  isPackageInstalled: async () => ({ isInstalled: false, message: 'Not implemented' }),
  Social: {},
};
module.exports.default = module.exports;
